export default "__VITE_ASSET__84Gg$eft__"